require("-!/tmp/build_40d67fa7/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!style-loader!css-loader!sass-loader!/tmp/build_40d67fa7/node_modules/bootstrap-sass-loader/bootstrap-sass-styles.loader.js!/tmp/build_40d67fa7/src/theme/bootstrap.config.prod.js");
require("-!/tmp/build_40d67fa7/node_modules/bootstrap-sass-loader/bootstrap-sass-scripts.loader.js!/tmp/build_40d67fa7/src/theme/bootstrap.config.prod.js");


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-sass-loader/index.loader.js!./src/theme/bootstrap.config.prod.js
// module id = 768
// module chunks = 0